<div class="home_page">
    <div class="header">{{ $t('websiteTitle') }}<span @click="loginout">退出</span></div>
    <div class="sale_table">
        <div class="select_bar">
            <div class="date_pink_position">
                <div class="saleSelectTitle">{{ $t('salesInquiry') }}</div>
                <div class="date_pinker_range">
                    <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                        <input id="startpicker-input" type="text" aria-label="Date" />
                        <span class="tui-ico-date"></span>
                        <div id="startpicker-container"></div>
                    </div>
                    <span>-</span>
                    <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                        <input id="endpicker-input" type="text" aria-label="Date" />
                        <span class="tui-ico-date"></span>
                        <div id="endpicker-container"></div>
                    </div>
                </div>
            </div>
            <div class="select_bar_right">
                <input type="file" id="uploadData" accept="xlsx" style="display: none" @change="uploadExcelData" />
                <button class="upload_position mdc-button mdc-button--raised" @click="chooseFile">
                    <div class="mdc-button__ripple"></div>
                    <i class="material-icons mdc-button__icon" aria-hidden="true">cloud_upload</i>
                    <span class="mdc-button__label">{{ $t('upload') }}</span>
                  </button>
                <button class="upload_position mdc-button mdc-button--outlined" @click="download">
                    <div class="mdc-button__ripple"></div>
                    <i class="material-icons mdc-button__icon" aria-hidden="true">cloud_download</i>
                    <span class="mdc-button__label">{{ $t('export') }}</span>
                  </button>
                  <button class="upload_position mdc-button mdc-button--outlined" @click="viewDevice">
                    <div class="mdc-button__ripple"></div>
                    <i class="material-icons mdc-button__icon" aria-hidden="true">visibility</i>
                    <span class="mdc-button__label">{{ $t('cherryDeviceInfo') }}</span>
                  </button>
            </div>
        </div>
        <sales-table v-on:openchart="openChart" v-on:setAsMainProduct="setAsMainProduct" :homeInfoData="homeInfoData" />
    </div>
    <sales-chart v-on:closechart="closeChart" v-on:showmessage="showMessage" :chartIds="chartIds"
        :chartCode="chartCode" :chartAttr="chartAttr"/>
    <stock-bind v-on:closebind="closeBind" v-on:showmessage="showMessage" v-on:updatedata="updateData"
        :excelBindData="excelBindData" />
</div>
<show-message :messageContent="messageContent" />
<!-- <div class="cherry_device_button"><a href="https://storage.joyway.net/devices" target="_blank">{{ $t('cherryDeviceInfo') }} ></a></div> -->
